import Svg, { SvgProps } from './Svg';

export default function LockStakeIcon({ ...props }: SvgProps) {
  return (
    <Svg
      viewBox="0 0 34 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M16.7272 20.811C20.0604 18.8829 22.3029 15.2791 22.3029 11.1515L22.2527 11.1116C22.2377 7.01456 20.0061 3.43559 16.7017 1.50948L16.7272 1.49188C18.3674 0.54305 20.2718 0 22.303 0C28.4617 0 33.4544 4.99268 33.4544 11.1515C33.4544 15.3079 31.1804 18.9333 27.8086 20.8513C27.8086 20.8513 27.7663 20.9633 27.7514 20.9717C26.1374 21.88 24.2886 22.3874 22.3046 22.3874C20.2884 22.3874 18.3971 21.8523 16.765 20.9164C16.753 20.9095 16.7272 20.811 16.7272 20.811Z"
        fill="url(#paint0_linear_1_1207)"></path>
      <path
        d="M27.8097 20.8506C26.1852 21.7748 24.306 22.3026 22.3034 22.3026C16.1446 22.3026 11.1519 17.3099 11.1519 11.1511L11.0419 11.1284C7.70385 13.0275 5.5213 16.6018 5.47681 20.7063L5.50704 20.7666C5.50684 20.7938 5.50675 20.8211 5.50675 20.8483C5.50675 27.0071 10.4994 31.9998 16.6582 31.9998C22.8162 31.9998 27.8084 27.0083 27.8097 20.8506Z"
        fill="url(#paint1_linear_1_1207)"></path>
      <path
        d="M20.4236 4.95604C21.6489 6.78989 22.3029 8.94591 22.3029 11.1515H11.1516C7.80175 13.0572 5.5356 16.646 5.50665 20.7687C5.32016 20.6592 5.13654 20.5442 4.95604 20.4236C3.1222 19.1982 1.69289 17.4566 0.848859 15.4189C0.00483176 13.3813 -0.216004 11.1391 0.214277 8.97592C0.644559 6.81275 1.70663 4.82575 3.26619 3.26619C4.82575 1.70663 6.81275 0.644559 8.97592 0.214277C11.1391 -0.216004 13.3813 0.00483176 15.4189 0.848859C17.4566 1.69289 19.1982 3.1222 20.4236 4.95604Z"
        fill="url(#paint2_linear_1_1207)"></path>
      <defs>
        <linearGradient
          id="paint0_linear_1_1207"
          x1="19.9811"
          y1="22.3029"
          x2="25.0908"
          y2="0.00000221528"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F7A7F9"></stop>
          <stop offset="1" stopColor="#00DDFB"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_1207"
          x1="1.42752"
          y1="24.9281"
          x2="20.7392"
          y2="36.0798"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F7A7F9"></stop>
          <stop offset="1" stopColor="#6D28FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1_1207"
          x1="-0.582554"
          y1="21.2197"
          x2="17.5983"
          y2="1.72198"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFF3D0"></stop>
          <stop offset="1" stopColor="#FFC044"></stop>
        </linearGradient>
      </defs>
    </Svg>
  );
}
